import { Navigate } from "react-router-dom";
import { canAccessDesk, defaultPathForRole, productLabel } from "../../js/auth/packageAccess";
import { useAuth } from "../../js/hooks/useAuth";

/**
 * Ensures the signed-in account's product includes the requested desk surface.
 * Admin always passes. Clients without a subscription use role-only routing elsewhere.
 */
export default function RequirePackageDesk({ desk, children }) {
  const { session } = useAuth();

  if (!session?.role) {
    if (desk === "buyer") return children;
    if (desk === "seller") return children;
    return <Navigate to="/login" replace />;
  }

  if (session.role === "admin") return children;

  if (canAccessDesk(session, desk)) return children;

  const home = defaultPathForRole(session.role) || "/";
  return (
    <div className="card page-header" style={{ margin: "1.5rem auto", maxWidth: "42rem" }}>
      <h1>Wrong desk for your plan</h1>
      <p className="page-lead">
        {productLabel(session)} does not include the {desk} console. You were kept on the platform
        designed for your account type.
      </p>
      <p>
        <a className="primary-btn" href={home}>
          Go to your desk
        </a>
      </p>
    </div>
  );
}
